module.exports = __webpack_public_path__ + "static/assets/156fe60b4b49631679123309e917ef3c.svg";